import { render, staticRenderFns } from "./start.vue?vue&type=template&id=d429abc4&lang=pug"
import script from "./start.vue?vue&type=script&lang=coffee"
export * from "./start.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports